export default "__VITE_ASSET__huENdJUE__"